'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearExistingAgentTypingTimeout = undefined;

var _pubnubMessageGetters = require('conversations-schema/pubnub-message/operators/pubnubMessageGetters');

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _agentTypingStates = require('../../typing-indicators/selectors/agentTypingStates');

var _getTypingTimeoutIdForAgentInThread = require('../../typing-indicators/operators/getTypingTimeoutIdForAgentInThread');

var clearExistingAgentTypingTimeout = exports.clearExistingAgentTypingTimeout = function clearExistingAgentTypingTimeout(message) {
  return function (dispatch, getState) {
    var threadId = (0, _pubnubMessageGetters.getThreadId)(message);
    var senderId = (0, _commonMessageFormatGetters.getSenderId)(message);
    var agentTypingStates = (0, _agentTypingStates.agentTypingStates)(getState());

    var existingTimeoutId = (0, _getTypingTimeoutIdForAgentInThread.getTypingTimeoutIdForAgentInThread)({
      threadId: threadId,
      agentId: senderId,
      agentTypingStates: agentTypingStates
    });

    if (typeof existingTimeoutId === 'number') {
      clearTimeout(existingTimeoutId);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/typing-indicators/actions/clearExistingAgentTypingTimeout.js
// module id = 225
// module chunks = 2 3